import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id EAE07425-A6D5-4B33-A9C5-6D7E9E9E1908
 * name forward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forward.svg
 * tags
 * - Arrow 
 */
export const ForwardIcon = createSvgIcon(<><path d="M12,8V4L20,12L12,20V16H4V8H12Z" /></>, 'ForwardIcon');
export default ForwardIcon